module.exports = __webpack_public_path__ + "static/scale-model-of-the-pabst-mansion-in-milwaukee-wisconsin-5268e677458b33ca243825f83314e732.png";